import React, { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { func, object, string } from 'prop-types';
import cookies from 'react-cookies';
import { useError } from '@avon/component-library';
import IOSSwitch from '../IOSSwitch';
import { isMobile } from '../../utils/getDeviceType';
import backIcon from '../Notification/assets/back.svg';
import {
  getNotificationSettings,
  editNotificationSetting,
  getNotificationSnsReceipt,
  // getNotificationSnsList,
} from '../../utils/api/endpoints';

// eslint-disable-next-line
const NotificationSetting = ({ callApi, setMenuItem }) => {

  const useStyles = makeStyles(theme => ({
    title: {
      fontWeight: '500',
      fontSize: 24,
      lineHeight: '32px',
      marginBottom: theme.spacing(6),
    },
    divider: {
      background: 'rgba(0, 0, 0, 0.0784314)',
      height: 1,
      marginBottom: theme.spacing(6),
    },
    dividerContainer: {
      padding: '18px 14px 6px',
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: '24px',
    },
  }));
  const theme = useTheme();
  const classes = useStyles();
  const { setError, cleanToastBanner } = useError();
  const [allow, setAllow] = useState(false);
  const [categories, setCategories] = useState([]);
  const [snsReceipt, setSnsReceipt] = useState({});
  const language = cookies.load('langCd');

  const getNotificationSettingData = async (receipt) => {
    try {
      cleanToastBanner();
      const {
        allSelect, newLead, rejected, expire, completed, survey, // avonMessage,
      } = await callApi(getNotificationSettings());
      setAllow(allSelect);
      setCategories([
        { checked: newLead, label: receipt.newLead, value: 'newLead' },
        { checked: rejected, label: receipt.rejected, value: 'rejected' },
        { checked: expire, label: receipt.expire, value: 'expire' },
        { checked: completed, label: receipt.completed, value: 'completed' },
        { checked: survey, label: receipt.survey, value: 'survey' },
        // { checked: avonMessage, label: receipt.drivenNotifications, value: 'avonMessage' },
      ]);
    } catch ({ error }) {
      setError(error);
    }
  };

  useEffect(() => {
    const findNotificationSnsReceipt = async () => {
      const { jsonObject: { receipt } } = await callApi(getNotificationSnsReceipt());
      setSnsReceipt(receipt);
      getNotificationSettingData(receipt);
    };
    findNotificationSnsReceipt();
  }, []);

  const toggleOptOut = async (data, index) => {
    try {
      cleanToastBanner();
      if (Number(index) === -1) {
        const copyCategories = JSON.parse(JSON.stringify(categories));
        copyCategories.forEach((item) => {
          // eslint-disable-next-line
          item.checked = !allow;
        });
        setCategories([...copyCategories]);
        setAllow(!allow);
      } else {
        const copyCategories = JSON.parse(JSON.stringify(categories));
        copyCategories[index].checked = !copyCategories[index].checked;
        setCategories([...copyCategories]);
        const someChecked = copyCategories.some(item => item.checked);
        const everyNotChecked = copyCategories.every(item => !item.checked);
        if (someChecked) {
          setAllow(true);
        }
        if (everyNotChecked) {
          setAllow(false);
        }
      }
      await callApi(editNotificationSetting(data));
      // getNotificationSettingData();
    } catch ({ error }) {
      setError(error);
    }
  };

  const Switch = ({
    label, style, fontSize = 16, lineHeight = '18px', ...props
  }) => (
    <Box style={Object.assign({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    // padding: '14px 14px 14px 8px',
    // border: '1px solid #E4EDED',
    // borderRadius: 4,
    }, style)}
    >
      <Box style={{
        fontWeight: '500',
        fontSize,
        lineHeight,
      }}
      >
        {label}
      </Box>
      <IOSSwitch size="medium" {...props} />
    </Box>
  );
  Switch.propTypes = {
    label: string,
    style: object,
    fontSize: string,
    lineHeight: string,
  };

  return isMobile() ? (
    <Box height="100%" bgcolor="#F6F9F9">
      <Box
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '10px 0',
          borderBottom: '1px solid rgba(0, 0, 0, 0.0784314)',
          background: '#ffffff',
        }}
      >
        <Box
          style={{
            position: 'absolute',
            left: 16,
            width: 24,
            height: 24,
          }}
          onClick={() => setMenuItem('home')}
        >
          <img src={backIcon} alt="back-icon" />
        </Box>
        <Box style={{
          fontFamily: 'Montserrat',
          fontWeight: 500,
          fontSize: 16,
          lineHeight: '24px',
          color: '#181818',
        }}
        >
          {snsReceipt.notifications}
        </Box>
      </Box>
      <Box style={{
        display: 'flex',
        background: '#ffffff',
      }}
      >
        <Switch
          style={{
            padding: 16,
            borderBottom: '1px solid rgba(0, 0, 0, 0.0784314)',
            flex: 1,
          }}
          lineHeight="24px"
          checked={allow}
          onChange={() => {
            toggleOptOut({ allSelect: !allow }, -1);
          }}
          label={snsReceipt.allSelect}
          value="toggleOptOut"
          id="allow-notifications"
          name="optout-switch"
        />
      </Box>
      <Box className={classes.dividerContainer}>{snsReceipt.categories}</Box>
      {
        categories.map(({ checked, label, value }, index) => (
          <Switch
            style={{
              padding: 16,
              borderBottom: '1px solid rgba(0, 0, 0, 0.0784314)',
              flex: 1,
              background: '#ffffff',
            }}
            key={`notification-setting-switch-key-${index}`}
            checked={checked}
            onChange={() => toggleOptOut({ [value]: !checked }, index)}
            label={label}
            value={value}
            id={label}
            name={label}
          />
        ))
      }
    </Box>
  ) : (
    <Box style={{
      padding: theme.spacing(6),
      fontFamily: 'Montserrat',
      color: '#181818',
    }}
    >
      <Box className={classes.title}>{snsReceipt.notificationSetting}</Box>
      <Box style={{
        paddingTop: theme.spacing(4.5),
      }}
      >
        <Box className={classes.title}>
          {snsReceipt.pushNotifications}
        </Box>
        <Box style={{
          display: 'flex',
          paddingBottom: theme.spacing(7.5),
        }}
        >
          <Switch
            style={{
              padding: '14px 14px 14px 8px',
              border: '1px solid #E4EDED',
              borderRadius: 4,
              flexBasis: 'calc(50% - 18px)',
            }}
            checked={allow}
            onChange={() => {
              toggleOptOut({ allSelect: !allow }, -1);
            }}
            label={snsReceipt.allSelect}
            value="toggleOptOut"
            id="allow-notifications"
            name="optout-switch"
          />
        </Box>
      </Box>
      <Box className={classes.divider} />
      <Box>
        <Box className={classes.title}>
          {snsReceipt.categories}
        </Box>
        <Box style={{
          display: 'flex',
          paddingBottom: theme.spacing(7.5),
          flexWrap: 'wrap',
        }}
        >
          {
            categories.map(({ checked, label, value }, index) => (
              <Switch
                style={{
                  padding: '14px 14px 14px 8px',
                  border: '1px solid #E4EDED',
                  borderRadius: 4,
                  flexBasis: 'calc(50% - 9px)',
                  marginRight: index % 2 === 0 && language !== 'ar' ? theme.spacing(4.5) : 0,
                  marginLeft: index % 2 === 0 && language === 'ar' ? theme.spacing(4.5) : 0,
                  marginBottom: theme.spacing(3),
                }}
                key={`notification-setting-switch-key-${index}`}
                checked={checked}
                onChange={() => toggleOptOut({ [value]: !checked }, index)}
                label={label}
                value={value}
                id={label}
                name={label}
              />
            ))
          }
        </Box>
      </Box>
    </Box>
  );
};

NotificationSetting.propTypes = {
  callApi: func,
  setMenuItem: func,
};


export default NotificationSetting;
